import { NotificationGateway } from './notification-gateway.interface';

export const initNotificationAPI = (
  apiSlice: any,
  gateway: NotificationGateway
) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['Notification'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        getAllNotificationsByProject: builder.query({
          query: gateway.getAllNotificationsByProject,
          providesTags: ['Notification'],
        }),
        getAllNotificationTypes: builder.query({
          query: gateway.getAllNotificationTypes,
        }),
        postNotification: builder.mutation({
          query: gateway.postNotification,
          invalidatesTags: ['Notification'],
        }),
        deleteNotification: builder.mutation({
          query: gateway.deleteNotification,
          invalidatesTags: ['Notification'],
        }),
        patchNotification: builder.mutation({
          query: gateway.patchNotification,
          invalidatesTags: ['Notification'],
        }),
      }),
      overrideExisting: false,
    });
};

export interface NotificationSliceType {
  useGetAllNotificationsByProjectQuery: Function;
  useGetAllNotificationTypesQuery: Function;
  usePostNotificationMutation: Function;
  useDeleteNotificationMutation: Function;
  usePatchNotificationMutation: Function;
}
